import { 
  stripHtml, 
  estimateReadingTime, 
  generateExcerpt, 
  cleanTitle
} from './utils';

/**
 * @param {Object} apiArticle 
 * @returns {Object|null} 
 */
export const adaptArticleData = (apiArticle) => {
  if (!apiArticle) return null;

  const content = apiArticle.postContent || apiArticle.postContent || '';
  const cleanContent = stripHtml(content);
  const title = cleanTitle(apiArticle.postTitle || apiArticle.title || '');

  const slug = apiArticle.postName || apiArticle.slug || '';
  if (!slug || !title) return null;

  const idRaw = apiArticle.ID ?? apiArticle.id ?? null;
  const id = typeof idRaw === 'string' ? parseInt(idRaw, 10) : idRaw;

  const commentCountRaw = apiArticle.commentCount ?? 0;
  const commentCount = typeof commentCountRaw === 'string' ? parseInt(commentCountRaw, 10) : commentCountRaw;

  const authorRaw = apiArticle.author || {};
  const author = {
    id: authorRaw.ID ?? authorRaw.id ?? '0',
    name: authorRaw.displayName || authorRaw.name || 'Auteur inconnu',
    slug: authorRaw.userNicename || authorRaw.slug || '',
    email: authorRaw.userEmail || authorRaw.email || '',
    url: authorRaw.userUrl || authorRaw.url || ''
  };

  let permalink = apiArticle.guid || '';
  if (!permalink || permalink.trim() === '') {
    permalink = `/article/${slug}`;
  }

  return {
    id,
    title,
    excerpt: apiArticle.postExcerpt || apiArticle.postExcerpt || generateExcerpt(content, 150),
    content,
    cleanContent,

    slug,

    postDate: apiArticle.postDate || apiArticle.date || null,
    postDateGmt: apiArticle.postDateGmt || null,
    postModified: apiArticle.postModified || null,
    postModifiedGmt: apiArticle.postModifiedGmt || null,

    image: apiArticle.image || null,

    postStatus: apiArticle.postStatus || 'publish',
    postType: apiArticle.postType || 'post',

    guid: apiArticle.guid || '',

    commentStatus: apiArticle.commentStatus || 'open',
    commentCount,

    categories: apiArticle.categories || [],
    tags: apiArticle.tags || [],

    author,

    readingTime: estimateReadingTime(content || cleanContent || ''),

    permalink,
    editLink: apiArticle.editLink || null
  };
};

/**
 * Adapte un tableau d'articles
 * @param {Array} apiArticles - Articles tels que retournés par l'API
 * @returns {Array} Articles formatés
 */
export const adaptArticlesData = (apiArticles) => {
  if (!Array.isArray(apiArticles)) {
    console.warn('adaptArticlesData: Expected array, got:', typeof apiArticles);
    return [];
  }
  
  return apiArticles
    .map(adaptArticleData)
    .filter(Boolean);
};

/**
 * @param {Object} article
 * @returns {boolean}
 */
export const isValidArticle = (article) => {
  return article &&
         typeof article.id === 'number' && !isNaN(article.id) &&
         typeof article.title === 'string' && article.title.trim() !== '' &&
         typeof article.slug === 'string' && article.slug.trim() !== '' &&
         article.postStatus === 'publish';
};

/**
 * @param {Array} articles
 * @returns {Array}
 */
export const filterPublishedArticles = (articles) => {
  return articles.filter(isValidArticle);
};


